import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/meta";

const NAV = [{ slug: "", name: "首页" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [dd, setDd] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const linkCls = "flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer";

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
          scrolled ? "border-background-200/80 bg-background-50/90 backdrop-blur-md" : "border-background-200/60 bg-background-50/70 backdrop-blur-sm"
        }`}
      >
        <div className="wrap flex h-16 items-center justify-between md:h-[72px]">
          {/* brand */}
          <Link to="/" className="group flex items-center gap-2.5" aria-label="吃瓜精选 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform duration-300 group-hover:-rotate-6">
              <i className="ri-vip-crown-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="serif text-lg font-black tracking-tight text-foreground-950">吃瓜精选</span>
              <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.28em] text-secondary-600">Chigua Picks</span>
            </span>
          </Link>

          {/* desktop nav */}
          <nav className="hidden items-center gap-6 lg:flex" aria-label="主导航">
            <Link to="/" className={linkCls}>
              <span className={`h-1.5 w-1.5 rounded-full bg-primary-500`} />
              首页
            </Link>
            <div className="relative" onMouseEnter={() => setDd(true)} onMouseLeave={() => setDd(false)}>
              <button
                type="button"
                onClick={() => setDd((v) => !v)}
                className={`${linkCls} gap-1`}
                aria-haspopup="true"
                aria-expanded={dd}
              >
                栏目盘点
                <i className={`ri-arrow-down-s-line text-base transition-transform ${dd ? "rotate-180" : ""}`} />
              </button>
              {dd && (
                <div className="absolute left-1/2 top-full mt-3 w-56 -translate-x-1/2 rounded-xl border border-background-200 bg-background-50 p-2 shadow-sm">
                  {categories.map((c) => (
                    <Link
                      key={c.slug}
                      to={`/category/${c.slug}`}
                      onClick={() => setDd(false)}
                      className="flex items-center gap-3 rounded-lg px-3 py-2.5 transition-colors hover:bg-background-100"
                    >
                      <span className="h-2 w-2 rounded-full bg-accent-500" />
                      <span className="flex flex-col">
                        <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                        <span className="text-xs text-secondary-600">{c.brief}</span>
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/about" className={linkCls}>
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              关于我们
            </Link>
            <Link to="/faq" className={linkCls}>
              <span className="h-1.5 w-1.5 rounded-full bg-secondary-500" />
              常见问题
            </Link>
          </nav>

          {/* actions */}
          <div className="hidden items-center gap-3 lg:flex">
            <Link
              to="/#collections"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line" />
              年度专题
            </Link>
          </div>

          {/* mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 lg:hidden"
            aria-label="打开菜单"
          >
            <i className="ri-menu-3-line text-2xl" />
          </button>
        </div>
      </header>

      {/* mobile drawer */}
      <div className={`fixed inset-0 z-[60] lg:hidden ${open ? "" : "pointer-events-none"}`}>
        <div
          onClick={() => setOpen(false)}
          className={`absolute inset-0 bg-foreground-950/40 backdrop-blur-sm transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
        />
        <div
          className={`absolute right-0 top-0 flex h-full w-[300px] max-w-[82%] flex-col bg-background-50 transition-transform duration-300 ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex h-16 items-center justify-between border-b border-background-200 px-5">
            <span className="serif text-lg font-black text-foreground-950">吃瓜精选</span>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
              aria-label="关闭菜单"
            >
              <i className="ri-close-line text-xl" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-4 py-4">
            <Link
              to="/"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold text-foreground-900 hover:bg-background-100"
            >
              <i className="ri-home-4-line text-lg text-primary-600" /> 首页
            </Link>
            <p className="mt-4 px-3 text-xs font-bold uppercase tracking-[0.2em] text-secondary-500">栏目盘点</p>
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                onClick={() => setOpen(false)}
                className="mt-1 flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                <span className="h-2 w-2 rounded-full bg-accent-500" /> {c.name}
              </Link>
            ))}
            <p className="mt-4 px-3 text-xs font-bold uppercase tracking-[0.2em] text-secondary-500">站点</p>
            <Link
              to="/about"
              onClick={() => setOpen(false)}
              className="mt-1 flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              <i className="ri-compass-3-line text-lg text-primary-600" /> 关于我们
            </Link>
            <Link
              to="/faq"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              <i className="ri-question-line text-lg text-primary-600" /> 常见问题
            </Link>
          </div>
          <div className="border-t border-background-200 p-4">
            <Link
              to="/#collections"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-fire-line" /> 进入年度专题
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}